import { useState, type FormEvent } from 'react';
import './LoginPage.css';

export default function LoginPage() {
  const [mallId, setMallId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // 이미 설치한 경우 mall_id로 재로그인
  const handleRelogin = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    const trimmed = mallId.trim().toLowerCase();
    if (!trimmed) {
      setError('쇼핑몰 ID를 입력해주세요.');
      return;
    }

    // mall_id 형식 검증: 영문 소문자, 숫자, 하이픈만 허용
    if (!/^[a-z0-9-]+$/.test(trimmed)) {
      setError('쇼핑몰 ID는 영문 소문자, 숫자, 하이픈(-)만 사용할 수 있습니다.');
      return;
    }

    setIsLoading(true);

    try {
      // 카페24 OAuth 재인증: install 엔드포인트로 직접 이동
      // (카페24 앱스토어에서 HMAC 서명 없이는 직접 접근 불가하므로
      //  실제로는 카페24 앱 관리 페이지에서 재실행해야 합니다)
      window.location.href = `https://${trimmed}.cafe24.com/disp/admin/shop/app/`;
    } catch {
      setError('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card card">
        {/* 헤더 */}
        <div className="login-page__header">
          <div className="login-page__logo">🤖</div>
          <h1 className="login-page__title">오팀장</h1>
          <p className="login-page__subtitle">AI 쇼핑몰 운영팀에 오신 걸 환영합니다</p>
        </div>

        {/* 카페24 설치 안내 */}
        <div className="login-page__cafe24-guide">
          <div className="login-page__guide-box">
            <h2 className="login-page__guide-title">카페24 앱스토어에서 설치하세요</h2>
            <p className="login-page__guide-desc">
              오팀장은 카페24 앱스토어를 통해 설치하고 로그인합니다.
              <br />
              카페24 앱스토어에서 &quot;오팀장&quot;을 검색하여 설치해주세요.
            </p>
            <a
              href="https://store.cafe24.com/kr/apps"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-block"
            >
              카페24 앱스토어 바로가기
            </a>
          </div>

          <div className="login-page__divider">
            <span>이미 설치하셨나요?</span>
          </div>

          {/* 재로그인 폼 */}
          <form className="login-page__form" onSubmit={(e) => void handleRelogin(e)}>
            <p className="login-page__relogin-desc">
              쇼핑몰 ID를 입력하면 카페24 앱 관리 페이지로 이동합니다.
            </p>
            <div className="form-group login-page__mall-id-group">
              <label className="form-label" htmlFor="mallId">
                쇼핑몰 ID
              </label>
              <div className="login-page__mall-id-input-wrap">
                <input
                  id="mallId"
                  type="text"
                  className="form-input"
                  placeholder="myshop"
                  value={mallId}
                  onChange={(e) => setMallId(e.target.value)}
                  autoComplete="off"
                  autoCapitalize="none"
                />
                <span className="login-page__mall-id-suffix">.cafe24.com</span>
              </div>
            </div>

            {error && (
              <div className="alert alert-error">{error}</div>
            )}

            <button
              type="submit"
              className="btn btn-secondary btn-block"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner" />
              ) : (
                '카페24 앱 관리 페이지로 이동'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
